import React from "react";
import { createPortal } from "react-dom";
import { CheckCircle2, X } from "lucide-react";

export default function DashboardRecommendationModal({
  selectedRecommendation,
  onClose,
  onNavigateStudents,
  onConfirm,
  icons,
}) {
  if (!selectedRecommendation) return null;

  const headerGradient = selectedRecommendation.id.startsWith("birth")
    ? "bg-gradient-to-br from-yellow-100 to-yellow-50"
    : selectedRecommendation.id.startsWith("absent")
      ? "bg-gradient-to-br from-red-100 to-red-50"
      : selectedRecommendation.id.startsWith("new")
        ? "bg-gradient-to-br from-green-100 to-green-50"
        : "bg-gradient-to-br from-blue-100 to-blue-50";

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-[#FAFAFA]/95 backdrop-blur-2xl rounded-[2.5rem] w-full max-w-sm relative shadow-2xl border border-white/60 overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className={`h-32 relative overflow-hidden ${headerGradient}`}>
          <div className="absolute top-[-20%] right-[-10%] w-32 h-32 rounded-full bg-white/20 blur-xl"></div>
          <div className="absolute bottom-[-10%] left-[-10%] w-24 h-24 rounded-full bg-white/30 blur-xl"></div>
          <button onClick={onClose} className="absolute top-5 right-5 p-2 bg-white/40 hover:bg-white/80 active:scale-95 backdrop-blur-md rounded-full text-gray-600 transition shadow-sm border border-white/20 z-10">
            <X size={20} />
          </button>
        </div>

        <div className="px-6 relative -mt-12 mb-6 flex flex-col items-center text-center">
          <div className="w-24 h-24 rounded-[2rem] bg-white shadow-[0_8px_30px_rgba(0,0,0,0.08)] flex items-center justify-center border-4 border-white/80 mb-4 rotate-[-3deg] hover:rotate-0 transition-transform duration-300">
            <img src={selectedRecommendation.icon} alt="icon" className="w-14 h-14 object-contain drop-shadow-md" />
          </div>

          <div className="space-y-1">
            <span className={`px-3 py-1 rounded-full text-[10px] font-bold shadow-sm ${selectedRecommendation.color} saturate-50 flex items-center justify-center gap-1 mx-auto w-fit`}>
              {selectedRecommendation.id.startsWith("new") ? (
                <>새가족 <img src={icons.seedling} alt="seedling" className="w-4 h-4 inline-block" /></>
              ) : (
                selectedRecommendation.reason
              )}
            </span>
            <h3 className="text-2xl font-black text-[#2C3E30] font-do-hyeon mt-2">{selectedRecommendation.name}</h3>
          </div>
        </div>

        <div className="px-6 pb-8 space-y-6">
          <div className="p-5 rounded-[2rem] bg-white shadow-[0_4px_20px_rgba(0,0,0,0.03)] border border-gray-50 flex items-center gap-4">
            <div className={`p-3 rounded-2xl ${selectedRecommendation.color.replace("text-", "bg-").split(" ")[0]} bg-opacity-10 shadow-inner flex items-center justify-center w-14 h-14`}>
              <img src={icons.lightbulb} alt="idea" className="w-8 h-8" />
            </div>
            <div className="text-left flex-1 min-w-0">
              <p className="text-[10px] text-gray-400 font-bold mb-0.5 uppercase tracking-wider">SUGGESTION</p>
              <p className="text-lg font-black text-gray-800 word-keep-all leading-tight">{selectedRecommendation.action}</p>
            </div>
          </div>

          <div className="flex gap-3 pt-2">
            <button
              onClick={() => onNavigateStudents?.(selectedRecommendation)}
              className="flex-1 py-3.5 bg-gray-100 text-gray-500 rounded-2xl font-bold hover:bg-gray-200 transition text-sm"
            >
              학생 명부
            </button>
            <button onClick={onConfirm} className={`flex-1 py-3.5 text-white rounded-2xl font-bold transition shadow-lg hover:shadow-xl hover:-translate-y-0.5 active:scale-95 text-sm flex items-center justify-center gap-2 ${selectedRecommendation.btnColor}`}>
              확인 완료 <CheckCircle2 size={16} />
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
